import { useCallback } from "react";
import { logout } from "../../../acions/auth";
import ROUTES from "../../../configs/routesConfig";
import { useNavigate, NavigateFunction } from "react-router-dom";
import { useAppDispatch } from "../../../store";

export const useLogout = () => {
  const dispatch = useAppDispatch();

  const navigate: NavigateFunction = useNavigate();

  const onLogout = useCallback((): void => {
    Promise.resolve(dispatch(logout()))
      .then(() => navigate(ROUTES.LOGIN))
      .catch(() => {});
  }, [dispatch, navigate]);

  return { onLogout };
};
